// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"39":"e62861d2","53":"271d16cd","242":"062671d4","270":"befca2d0","706":"12768fe5","947":"c6a2badb"}[chunkId] + ".chunk.js";
};